import { Group, Radio } from '@mantine/core';
import { Coding } from '@medplum/fhirtypes';
import { AMBULATORY_ENCOUNTER_CLASS_CODING, VIRTUAL_ENCOUNTER_CLASS_CODING } from '@bariendo/lib/codings';

interface VisitTypeInputProps {
  value: Coding;
  onChange: (encounterClass: Coding) => void;
}

export function VisitTypeInput({ value, onChange }: VisitTypeInputProps) {
  const selectedValue = value.code === AMBULATORY_ENCOUNTER_CLASS_CODING.code ? 'in-person' : 'virtual';

  const handleChange = (val: string) => {
    const encounterClass = val === 'in-person' ? AMBULATORY_ENCOUNTER_CLASS_CODING : VIRTUAL_ENCOUNTER_CLASS_CODING;
    onChange(encounterClass);
  };

  return (
    <Radio.Group label="Visit type" value={selectedValue} onChange={handleChange} required>
      <Group>
        <Radio value="virtual" label="Virtual" size="xs" />
        <Radio value="in-person" label="In-person" size="xs" />
      </Group>
    </Radio.Group>
  );
}
